import React from "react";
import { useForm } from "react-hook-form";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { MuiTelInput } from "mui-tel-input";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { useEffect } from "react";
import moment from "moment";
import PostHooks from "../../../../Api/PostHooks";
import AlertComponent from "../../../../Components/AlertComponent";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import FormNumberInput from "../../../../Components/FormNumberInput";

const EditKinForm = ({ _user, data, onClose, onSuccess }) => {
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const location = useLocation();
  const loggedInUser = useSelector((state) => state.auth.user);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [user, setUser] = useState(
    _user || location?.state?.user || loggedInUser,
  );

  const [loading, response, request] = PostHooks();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const onSubmit = async (e) => {
    try {
      let formData = {
        entity_id: user.user?.id,
        next_kin_id: data?.next_kin_id,
        allocation: e.allocation,
      };

      let props = {
        url: "/next_kin_allocation",
        body: formData,
      };

      const editResp = await request(props);

      if (
        editResp &&
        editResp.status === 200 &&
        editResp.data.StatusCode === 0
      ) {
        setSnackbar({
          open: true,
          severity: "success",
          message: "Next Kin updated successfully!",
        });
        setTimeout(() => {
          onClose();
          onSuccess();
        }, 1000);
      } else {
        const errorMessage =
          editResp?.data?.StatusMessage ??
          editResp?.data?.message ??
          editResp.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  return (
    <div>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <form onSubmit={handleSubmit(onSubmit)} id="form">
        <Box
          sx={{
            paddingTop: "20px",
          }}
        >
          <FormNumberInput
            name="allocation"
            control={control}
            label={`Allocation`}
            rules={{
              required: "Required",
            }}
          />
          {/* <FormControl fullWidth error={!!errors.allocation}>
            <InputLabel htmlFor="allocation">Allocation</InputLabel>
            <OutlinedInput
              variant="filled"
              id="allocation"
              {...register("allocation", { required: true })}
              label="Allocation"
              type="number"
              defaultValue={user?.allocation}
              inputProps={{ step: "any", min: 0 }}
            />
            {errors.allocation && <FormHelperText>Required</FormHelperText>}
          </FormControl> */}
        </Box>

        <Box
          sx={{
            pt: "20px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            size="large"
            type="reset"
            variant="outlined"
            onClick={() => onclose()}
          >
            cancel
          </Button>
          <LoadingButton
            variant="contained"
            sx={{ ml: "10px" }}
            size="large"
            type="submit"
            loading={loading}
          >
            Update
          </LoadingButton>
        </Box>
      </form>
    </div>
  );
};

export default EditKinForm;
